export const CASE_STUDIES_PERMISSIONS = {
  CASE_STUDIES_READ:   'case-studies:read',
  CASE_STUDIES_CREATE: 'case-studies:create',
  CASE_STUDIES_UPDATE: 'case-studies:update',
  CASE_STUDIES_DELETE: 'case-studies:delete',
} as const
